import ApisClient from '../utils/client/ApisClient';

export const getBills = (monthsRange: string) => {
    return ApisClient.get(`/bills?months=${monthsRange}`);
};

export const getBillDetail = (id?: string) => {
    return ApisClient.get(`/bills/detail?billId=${id}`);
};

export const downloadBill = (billId: string) => {
    return ApisClient.get(`/bills/download?billId=${billId}`, {
        headers: {
            'Content-type': 'application/pdf',
        },
        responseType: 'blob',
    });
};

export const getDebt = () => {
    return ApisClient.get('/bills/debt');
};

export const getDebtDetail = () => {
    return ApisClient.get('/bills/debt/detail');
};

export const rehabilitateLines = () => {
    return ApisClient.post('/bills/debt/rehabilitate');
};

export const generateGCOPaymentUrl = () => {
    return ApisClient.post('/bills/debt/payment');
};
